<ion-card>
  <img *ngIf="feed.image_urls && feed.image_urls.length > 0" [src]="feed.image_urls[0]" alt=""
    (click)="viewFeedDetails()">
  <img *ngIf="!feed.image_urls || feed.image_urls.length == 0" src="./assets/imgs/feed_biz.png" alt=""
    (click)="viewFeedDetails()">
  <ion-row>
    <ion-col size="9" style="">
      <div *ngIf="feed.json_details && feed.json_details.offerings" class="scrollable"
        [ngStyle]="{height: descriptionHeight,'display': 'flex','align-items': 'flex-start'}">
        <span class="bold">Offerings: </span>
        <ion-badge *ngFor="let item of feed.json_details.offerings.split(',')" mode="ios"
          class="margin2px">{{item}}</ion-badge>
      </div>
    </ion-col>
    <ion-col size="2">
    </ion-col>
    <ion-col size="1" style="height: 24vw;" class="scrollable">
      <div *ngIf="feed.reactionKeys">
        <div class="singleLine" *ngFor="let key of feed.reactionKeys">{{feed.reaction_count[key]}} {{key}}</div>
      </div>
    </ion-col>
  </ion-row>

  <ion-row class="creatorBox">
    <ion-col size="1.5">
      <span *ngIf="feed.creator">
        <img width="35px" height="35px" [src]="feed.creator.url" *ngIf="feed.creator && feed.creator.url"
          class="circular">
        <ion-icon name="person-circle-outline" *ngIf="!feed.creator.url" class="font3" color="light"></ion-icon>
      </span>
    </ion-col>
    <ion-col size="6">
      <div class="font1_5" (click)="viewFeedDetails()">{{feed.header}}</div>
      <!-- <div *ngIf="feed.creator" class="font0_8">By: {{feed.creator.name}}</div> -->
      <a class="imageData" style="color:white" *ngIf="feed.json_details.contact_number || feed.json_details.contact"
        [href]="'tel:'+feed.json_details.contact_number">
        <ion-row>
          <ion-col size="1">
            <ion-icon color="tertiary" name="call-outline"></ion-icon>
          </ion-col>
          <ion-col size="11">
            <div style="width: 100%; overflow-x: auto; white-space: nowrap;">
              <b>{{feed.json_details.contact}}</b>,{{feed.json_details.contact_number}}
            </div>
          </ion-col>
        </ion-row>
      </a>
    </ion-col>
    <ion-col size="1.5" class="font1_5">
      <ion-icon (click)="showEmojiBox = !showEmojiBox" name="heart-outline"></ion-icon>
    </ion-col>
    <ion-col size="1.5" class="font1_4">
      <ion-icon name="logo-whatsapp" (click)="feedService.share(feed)"></ion-icon>
    </ion-col>
    <ion-col size="1.5" class="font1_4">
      <ion-icon (click)="viewFeedDetails()" name="chatbubble-outline"></ion-icon>
    </ion-col>
  </ion-row>



  <ion-row *ngIf="showEmojiBox" class="emojiBox">
    <ion-col size="2" *ngFor="let emoji of reaction.emojiList" (click)="clickEmoji(emoji)" class="font1_5">
      {{emoji}}
    </ion-col>
  </ion-row>
</ion-card>